<template>
  <div class="mx-2">
    <v-chip-group

      :show-arrows="true"
      style="width: calc(100vw - 400px)"
    >
      <v-chip
        v-for="channel in activeChannels"
        :key="channel.sid"
        small
        close
        :color="colorForChannel(channel)"
        @click:close="closeChannel(channel)"
        @click="driverChannelSelected(channel)"
      >
        {{ channel.friendlyName }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
axios.defaults.withCredentials = true;
import moment from "moment";

export default {
  name: "OnlineChannelsMenu",
  components: {
  },
  data: function () {
    return {
      hideNavigation: false,
      contactNumberMap: null,
      onlineOnly: false,
      loadingData: false,
      showProgressBar: true,
      filter: "",
      menu: false,
      fullPage: true,
      openChat: false,
      accessToken: null,
      tc: {
        subscribedChannels: [],
        currentChannel: null,
        currentChannelMessages: null,
        activeChannels: [],
        localChannels: [],
      },
      prefix: "",
      messageList: [],
      identity: "",
      colors: {
        header: {
          bg: "#000000",
          text: "#ffffff",
        },
        launcher: {
          bg: "#000000",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "#4e8cff",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      },
      messageDialog: false,
      activeDriverIDS: [],
      driversIDToContactNumber: {}
    };
  },
  computed: {
    authUser () {
      return this.$store.state.authUser
    },
    currentChannel () {
      return this.$store.getters['messaging/getCurrentChannel']
    },
    isOpenChat () {
      return this.$store.getters['messaging/getIsOpenChat']
    },
    activeChannels () {
      return this.$store.getters['messaging/getActiveChannels']
    },
    loadingDialog() {
      return this.$store.getters['loadingDialog']
    },
    loggedIn: function () {
      return this.$store.getters.getLoggedIn;
    },
    name: function () {
      return this.$store.getters.getName;
    },
    isLoading: function () {
      return this.$store.state.loading;
    },
    driverToMessage: function () {
      return this.$store.state.driverToMessage;
    },
    localChannelsFiltered: function () {
      var filter = this.filter;

      var activeDriverIDS = this.activeDriverIDS;
      return this.tc.localChannels
          .filter(function (f) {
            if (filter == null || filter.length == 0) {
              return activeDriverIDS.indexOf(f.sid) > -1;
            }

            return (
                activeDriverIDS.indexOf(f.sid) > -1 &&
                f.friendlyName.toLowerCase().includes(filter.toLowerCase())
            );
          })
          .sort(function (a, b) {
            return a.friendlyName
                .split(" ")[1]
                .localeCompare(b.friendlyName.split(" ")[1]);
          });
    },

  },
  mounted: function () {
    // this.$store.state.driverToMessage = null;
    // this.fetchAccessToken();
    // this.fetchActiveDriverIds();
  },
  methods: {
    isNewNotification (c) {
      if (
        c.lastMessage != null &&
        c.lastReadMessageIndex < c.lastMessage.index
      ) {
        return true
      } else {
        return false;
      }
    },
    colorForChannel(c) {
      if (
          c.lastMessage != null &&
          c.lastReadMessageIndex < c.lastMessage.index
      ) {
        return "blue lighten-2";
      } else {
        return "grey lighten-2";
      }
    },
    driverChannelSelected(channel) {
      if (this.isNewNotification(channel)) {
        this.$store.commit("messaging/setChatOpenedBy", this.authUser)
      }
      this.$store.commit('messaging/setSelectedDriverChannel', channel)
    },
    closeChannel(channel) {
      this.$store.commit('messaging/setIsOpenChat', false)
      this.$store.commit('messaging/setClosingChannel', channel)
    }
  },
};
</script>

<style scoped>

</style>